import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { filter } from 'rxjs/operators';
import { AuthService } from '../../../auth/services/auth.service';
import { PlanChangeConfirmationComponent } from "../../../components/plan-change-confirmation/plan-change-confirmation.component";
import { Plan } from '../../models/plan.model';
import { AccountService } from '../../services/account.service';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-side-content-column',
  standalone: true,
  imports: [CommonModule, PlanChangeConfirmationComponent],
  templateUrl: './side-content-column.component.html',
  styleUrls: ['./side-content-column.component.scss']
})
export class SideContentColumnComponent implements OnInit {
  isRecentAdsRoute = false;
  account: any = null;
  // Plan change confirmation dialog
  showPlanChangeConfirmation = false;
  currentPlan: Plan | null = null;
  newPlan: Plan | null = null;
  isChangingPlan = false;
  availablePlans: Plan[] = [];

  constructor(
    private router: Router,
    private authService: AuthService,
    private accountService: AccountService,
    private toastService: ToastService
  ) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.isRecentAdsRoute = event.url.startsWith('/recent-ads');
      }
    });
  }

  ngOnInit() {
    this.authService.currentUser$.subscribe((res: any) => {
      this.account = res;
    });
  }

  getUserProfile() {
    this.authService.getUserProfile().subscribe((res: any) => {
      window.localStorage.setItem('user', JSON.stringify(res.data));
      this.authService.currentUserSubject.next(res.data);
      this.account = res.data;
    });
  }


  get currentRoute(): string {
    return this.router.url;
  }

  isAccountPage(): boolean {
    return this.currentRoute.includes('/account');
  }

  isRecentAdsPage(): boolean {
    return this.currentRoute.includes('/recent-ads');
  }

  isDashboardPage(): boolean {
    return this.currentRoute.includes('/dashboard');
  }

  isPixelTrackingPage(): boolean {
    return this.currentRoute.includes('/pixel-tracking');
  }

  isAdBalancePage(): boolean {
    return this.currentRoute.includes('/ad-balance');
  }

  shouldShowCurrentPlanCard(): boolean {
    return this.isAdBalancePage() && 
           this.account?.current_subscription?.plan?.interval === 'month';
  }

  navigateToAccount(): void {
    this.router.navigate(['/account']);
  }

  openPlanChangeModal(): void {
    this.showPlanChangeConfirmation = true;
    this.getPlans();
  }

  getPlans(): void {
    this.accountService.getPlans().subscribe({
      next: (response) => {
        this.availablePlans = response.data;
        // Find the yearly plan to set as newPlan for upgrade
        this.currentPlan = this.availablePlans.find(plan => plan.interval === 'month') || null;
        this.newPlan = this.availablePlans.find(plan => plan.interval === 'year') || null;
      },
      error: (error) => {
        console.error('Error fetching plans:', error);
        this.toastService.showError('Failed to load available plans. Please try again.');
      }
    });
  }

  onPlanChangeConfirmed(confirmedPlan: Plan) {
    this.isChangingPlan = true;    
    this.accountService.changePlan(confirmedPlan.stripe_id).subscribe({
      next: (res: any) => {
        this.getUserProfile();
        this.toastService.showSuccess('Plan changed successfully');
        this.showPlanChangeConfirmation = false;
        this.isChangingPlan = false;
      },
      error: (error) => {
        console.error('Error changing plan:', error);
        const errorMessage = error?.error?.data?.message || error?.error?.message || 'Failed to change plan. Please try again.';
        this.toastService.showError(errorMessage);
        this.isChangingPlan = false;
      }
    });
  }
}
